import {HelpMessage} from '../content/HelpMessage';
import '../content/HelpMessage.scss';
import {Box, Container, List, ListItem, Typography} from '@mui/material';

export class RonaldeHelpMessage extends HelpMessage {
    override render() {
        return <Container>
            <List>
                <Typography display={"flex"} justifyContent="center" alignItems={"center"} variant={"h6"}>
                    Guess the mystery player!
                </Typography>
                <ListItem>
                    You get six guesses, try any current football player with a FIFA rating above 75!
                </ListItem>
                <ListItem sx={{display: "inline-block"}}>
                    <Box component="span" className={"highlight-green"}>Green in any column</Box>&nbsp;indicates a match
                </ListItem>
                <ListItem sx={{display: "inline-block"}}>
                    <Box component="span" className={"highlight-yellow"}>Yellow in the team
                        column</Box>&nbsp;indicates the same teams are in the same league
                </ListItem>
                <ListItem sx={{display: "inline-block"}}>
                    <Box component="span" className={"highlight-yellow"}>Yellow in the position
                        column</Box>&nbsp;indicates the same position group. Groups are Forwards, Midfielders, and Defenders
                </ListItem>
                <ListItem sx={{display: "inline-block"}}>
                    <Box component="span" className={"highlight-yellow"}>Yellow in any number
                        column</Box>&nbsp;indicates this attribute is within 2 (inches, years) of the mystery
                    player
                </ListItem>
                <ListItem sx={{display: "inline-block"}}>
                    A new mystery player every day!
                </ListItem>
            </List>
        </Container>;
    }
}
